import {designerUiComponentsList} from "@/components/DiagramDesigner/Editor/components/UI/designerUiComponentsList";

export const designerComponentsList = [
    ...designerUiComponentsList,
]
